import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { MyNewsListItemHeader } from "my-news/components";
import { OcCardButtonBar } from "oc/components";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

interface MyNewsItem {
  _id: string;
  read: boolean;
  priority: "high" | "normal" | string;
  description: string;
  // add other fields as needed
}

interface MyNewsListItemProps {
  item: MyNewsItem;
  isAdminList: boolean;
  setMyNewsItemRead?: (args: { variables: { _id: string } }) => void;
}

export const MyNewsListItem: React.FC<MyNewsListItemProps> = ({
  item,
  isAdminList,
  setMyNewsItemRead,
}) => {
  const history = useHistory();
  const theme = useTheme();
  const { t } = useTranslation();
  const isMobile = useOcIsMobile();

  const handleButtonClick = () => {
    if (!isAdminList) {
      setMyNewsItemRead && setMyNewsItemRead({ variables: { _id: item._id } });
    }
    history.push("/my-news/show/" + item._id);
  };

  let borderStyle = "none";

  if (!item.read) {
    switch (item.priority) {
      case "high":
        borderStyle = `2px solid ${theme.palette.yellowBase.main}`;
        break;
      case "normal":
        if (!isAdminList) {
          borderStyle = `2px solid ${theme.palette.blueBase.main}`;
        }
        break;
      default:
        borderStyle = "none";
        break;
    }
  }

  return (
    <Box
      id="news-card"
      padding={isMobile ? "0px 16px" : "0px 16px 16px 16px"}
      style={{
        border: borderStyle,
        borderRadius: "4px",
        backgroundColor: theme.palette.white.main,
      }}
    >
      <MyNewsListItemHeader
        item={{
          title: (item as any).title,
          editorName: (item as any).editorName,
          editorEmployeeCode: (item as any).editorEmployeeCode,
          publishedAt: (item as any).publishedAt,
          createdAt: (item as any).createdAt,
          validTo: (item as any).validTo,
          modifiedAt: (item as any).modifiedAt,
        }}
      />
      <Box height="16px" />
      <Typography variant="body1">{item.description}</Typography>
      <OcCardButtonBar
        handleRightButton={handleButtonClick}
        rightButtonColor="secondary"
        rightButtonVariant="outlined"
        rightButtonText={item?.read ? t("MY_NEWS_READ_AGAIN") : undefined}
        rightButtonId="read-button"
        handlePrimaryButton={handleButtonClick}
        primaryButtonText={!item?.read ? t("MY_NEWS_READ") : undefined}
        primaryButtonId="read-button"
      />
    </Box>
  );
};

export default MyNewsListItem;
